import Vue from 'vue'
import App from './App'
import router from './router'
import Vuetify from 'vuetify'
import './stylus/main.styl'
import './assets/css/global.css'
import colors from 'vuetify/es5/util/colors'
import store from './store'
import firebase from '@firebase/app'
import 'video.js/dist/video-js.css'

export const contentEvent = new Vue()
export const coursesEvent = new Vue()
export const quillEvent = new Vue()

Vue.use(Vuetify, { theme: {
  primary: colors.deepPurple.lighten3,
  secondary: colors.grey.darken3,
  accent: colors.amber.lighten2,
  error: colors.red.lighten2
}})

Vue.config.productionTip = false

firebase.initializeApp({
  apiKey: 'AIzaSyBRg9sc9K2UzAgvlOOEarBtmDEEN0H7TWc',
  authDomain: 'rophem-lms.firebaseapp.com',
  databaseURL: 'https://rophem-lms.firebaseio.com',
  projectId: 'rophem-lms',
  storageBucket: 'rophem-lms.appspot.com',
  appId: '1:644732364966:web:4e3ed3b9711941a3fcec67'
})
// firebase.initializeApp({
//   apiKey: 'AIzaSyD1nAMpzmDsS_SVZyGzG96GaQoNU_QSA_E',
//   authDomain: 'rophem-lms-dev.firebaseapp.com',
//   databaseURL: 'https://rophem-lms-dev.firebaseio.com',
//   projectId: 'rophem-lms-dev',
//   storageBucket: 'rophem-lms-dev.appspot.com'
// })

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js